<div class="grid-container">
  <div>
    <img
      src="https://storage.googleapis.com/ps-asset/affiliate/logo/kopetro-logo.png"
      alt="Prolindung Logo"
    />
    <div class="company-name">{{ info.company }}</div>
    <div class="company-address" [innerHTML]="info.address.value"></div>
  </div>

  <div>
    <div class="footer-header">proLindung Customer Careline</div>
    <div class="contact-wrapper">
      <div class="mobile">
        <img
          src="../../../../assets/icons/footer/mobile_new.svg"
          alt="Whatsapp Logo"
        />
      </div>
      <div>{{ info.mobile.value }}</div>
    </div>
    <div class="contact-wrapper">
      <div class="whatsapp">
        <img
          src="../../../../assets/icons/footer/whatsapp_new.svg"
          alt="Whatsapp Logo"
        />
      </div>
      <div>{{ info.mobile2.value }}</div>
    </div>
    <div class="contact-wrapper">
      <div class="email">
        <img
          src="../../../../assets/icons/footer/email_new.svg"
          alt="Whatsapp Logo"
        />
      </div>
      <div>{{ info.email.value }}</div>
    </div>
  </div>

  <div>
    <div class="footer-header">{{ "footer.social" | translate }}</div>
    <div class="social-wrapper">
      <a
        [href]="social.url"
        target="_blank"
        *ngFor="let social of socialMediaList[0].linkList"
      >
        <img [src]="social.icon" [alt]="social.alt" [title]="social.title" />
      </a>
    </div>
  </div>

  <div></div>
</div>

<ng-content></ng-content>
